<template>
  <FormContainer
    v-if="moduleEnCours?.typeModule === 'Externe'"
    id="module-scroll-externe"
    withoutDivider
  >
    <template #title>Recherche organisme</template>
    <template #content>
      <div class="form__bloc">
        <WrapperAutocomplete
          id="field_28"
          key-id="siret.valeur"
          key-label="denomination"
          :model-value="moduleEnCours?.etablissementPrestataire"
          @update:model-value="(value: any) => updateModule('etablissementPrestataire', activeModuleIndex!, value)"
          label="Rechercher un organisme de formation externe"
          class="col-18 col-md-22 col-sm-36"
          :search-min-length="9"
          :hint="HINT_SIREN_SIRET_OF"
          :placeholder="PLACE_HOLDER_SIREN"
          strict
          :required="metaModuleEnCours?.etablissementPrestataire?.siret?.valeur?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.etablissementPrestataire?.siret?.valeur?.$messageErreurDirty!"
          :readonly
          :search="searchPrestataire"
          :search-formater="sirenSiretSearchFormater"
        >
          <template v-slot="{ denomination, siret, adresse, estEtablissementSiege, etatAdministratif }">
            <div>
              <div>
                <BasicText weight="bold">{{ denomination }} - {{ siret.valeur }}</BasicText>
                <BasicText
                  v-if="estEtablissementSiege === true"
                  color="primary-600"
                >
                  - SIEGE
                </BasicText>
                <BasicText
                  v-if="etatAdministratif === 'F'"
                  color="red"
                >
                  (Inactif)
                </BasicText>
              </div>
              <div style="margin-top: -3px">
                <BasicText size="body-m">
                  {{ adresse?.voie }} {{ adresse?.codePostal }} {{ adresse?.commune }}
                </BasicText>
              </div>
            </div>
          </template>
        </WrapperAutocomplete>
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_unknown"
          :model-value="moduleEnCours?.etablissementPrestataire?.siret?.valeur"
          @update:model-value="
            (value: any) => updateModule('etablissementPrestataire.siret', activeModuleIndex!, value)
          "
          label="SIRET"
          class="col-8 col-md-12 col-sm-36"
          :required="metaModuleEnCours?.etablissementPrestataire?.siret?.valeur?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.etablissementPrestataire?.siret?.valeur?.$messageErreurDirty!"
          disabled
        />
        <WrapperInput
          id="field_unknown"
          :model-value="moduleEnCours?.etablissementPrestataire?.nda"
          @update:model-value="(value: any) => updateModule('etablissementPrestataire.nda', activeModuleIndex!, value)"
          label="N° d'activité"
          class="col-8 col-md-8 col-sm-36"
          :required="metaModuleEnCours?.etablissementPrestataire?.nda?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.etablissementPrestataire?.nda?.$messageErreurDirty!"
          disabled
        />
        <WrapperInput
          id="field_unknown"
          :model-value="qualiopiLibelle"
          @update:model-value="
            (value: any) => updateModule('etablissementPrestataire.certificationQualiopi', activeModuleIndex!, value)
          "
          label="Qualiopi"
          class="col-20 col-md-16 col-sm-36"
          disabled
          help="La certification Qualiopi est obligatoire pour tous les prestataires d'actions concourant au développement des compétences, et ce depuis le 1er janvier 2022."
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_unknown"
          :model-value="moduleEnCours?.etablissementPrestataire?.adresse?.voie"
          @update:model-value="
            (value: any) => updateModule('etablissementPrestataire.adresse.voie', activeModuleIndex!, value)
          "
          :label="LABEL_NUMERO_VOIE"
          class="col-12 col-md-16 col-sm-36"
          :required="metaModuleEnCours?.etablissementPrestataire?.adresse?.voie?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.etablissementPrestataire?.adresse?.voie?.$messageErreurDirty!"
          disabled
        />
        <WrapperInput
          id="field_unknown"
          :model-value="moduleEnCours?.etablissementPrestataire?.adresse?.complement"
          @update:model-value="
            (value: any) => updateModule('etablissementPrestataire.adresse.complement', activeModuleIndex!, value)
          "
          label="Complément d'adresse"
          class="col-12 col-md-16 col-sm-36"
          :required="
            metaModuleEnCours?.etablissementPrestataire?.adresse?.complement?.$status === PropertyStatus.Required
          "
          :alertLabel="metaModuleEnCours?.etablissementPrestataire?.adresse?.complement?.$messageErreurDirty!"
          disabled
        />
        <WrapperInput
          id="field_unknown"
          :model-value="moduleEnCours?.etablissementPrestataire?.adresse?.codePostal"
          @update:model-value="
            (value: any) => updateModule('etablissementPrestataire.adresse.codePostal', activeModuleIndex!, value)
          "
          label="Code postal"
          class="col-4 col-md-6 col-sm-36"
          :required="
            metaModuleEnCours?.etablissementPrestataire?.adresse?.codePostal?.$status === PropertyStatus.Required
          "
          :alertLabel="metaModuleEnCours?.etablissementPrestataire?.adresse?.codePostal?.$messageErreurDirty!"
          disabled
        />
        <WrapperInput
          id="field_unknown"
          :model-value="moduleEnCours?.etablissementPrestataire?.adresse?.commune"
          @update:model-value="
            (value: any) => updateModule('etablissementPrestataire.adresse.commune', activeModuleIndex!, value)
          "
          label="Commune"
          class="col-8 col-md-10 col-sm-36"
          :required="metaModuleEnCours?.etablissementPrestataire?.adresse?.commune?.$status === PropertyStatus.Required"
          Module
          :alertLabel="metaModuleEnCours?.etablissementPrestataire?.adresse?.commune?.$messageErreurDirty!"
          disabled
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { computed, inject } from 'vue'
  import { storeToRefs } from 'pinia'
  import type { ModuleDTO } from '@/features/api/extranet/dto/Demande/PROA'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import { CertificationQualiopiLibelle } from '@/features/domaine/types/opco'
  import {
    FormContainer,
    HINT_SIREN_SIRET_OF,
    LABEL_NUMERO_VOIE,
    PLACE_HOLDER_SIREN,
  } from '@/features/interface/demande/shared'
  import { PROA_INJECT, type DemandeProAActions } from '../../../../DemandePROA.type'
  import { useDemandePROAStore } from '../../../../useDemandePROAStore'
  import { ModuleActionKey, type ModuleAction } from '../../useModuleActions'
  import { sirenSiretSearchFormater } from '@/features/interface/shared/tools'

  const store = useDemandePROAStore()
  const { setupArrayUpdaterWithKey } = store
  const { model, readonly } = storeToRefs(store)
  const { activeModuleIndex, moduleEnCours, metaModuleEnCours } = inject<ModuleAction>(ModuleActionKey)!
  const { searchPrestataire } = inject<DemandeProAActions>(PROA_INJECT)!

  const updateModule = setupArrayUpdaterWithKey<ModuleDTO>('formation.modules')

  const qualiopiLibelle = computed(() => {
    return (
      model.value?.formation?.modules?.[activeModuleIndex.value!]?.etablissementPrestataire?.certificationQualiopi
        ?.map((item) => CertificationQualiopiLibelle[item])
        ?.join(', ') ?? ''
    )
  })
</script>
